import React, { useState } from 'react';
import { IAuthorNameProps } from './~types/AuthorNameProps';

import './AuthorName.css';
import { Dropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap';
import { ChatPanelRuleHelper } from 'src/app/shared/helpers/rule-helper/ChatPanelRuleHelper';
import { t } from 'i18next';

const AuthorName = (props: IAuthorNameProps) => {
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const toggleDropdownVisibility = () => {
        setIsDropdownVisible(!isDropdownVisible);
    }

    const canRemove = !props.isChatClosed &&
        ChatPanelRuleHelper.canRemoveOperatorFromChat(
            props.messageType,
            props.operatorId,
            props.messageOperatorId,
            props.chatOwnerId,
            props.isSupervisor,
            props.isChatParticipant
        );

    return (
        <>
            {!canRemove && (
                <div className={"author-name " + props.messageTypeClass}>
                    {props.authorName}
                </div>
            )}
            {canRemove && (
                <Dropdown
                    className="chat-footer__transfer-chat"
                    isOpen={isDropdownVisible}
                    toggle={(e: any) => {
                        if (!e.key || e.key === 'Esc') {
                            toggleDropdownVisibility();
                        }
                    }}
                >
                    <DropdownToggle
                        className={
                            "author-name dropdown-toggle " + props.messageTypeClass
                        }
                        onClick={() => {
                            toggleDropdownVisibility();
                        }}
                        onKeyUp={(e) => {
                            if (e.key === "Enter") {
                                toggleDropdownVisibility();
                            }
                        }}
                    >
                        {props.authorName}
                    </DropdownToggle>
                    <DropdownMenu
                        className={
                            "author-name__dropdown-actions " +
                            (!isDropdownVisible ? "dropdown-actions__closed" : "")
                        }
                    >
                        <DropdownItem
                            className={"author-name__action"}
                            onClick={() => {
                                props.onRemoveOperator();
                                toggleDropdownVisibility();
                            }}
                            tabIndex={0}
                            onKeyUp={(e) => {
                                if (e.key === "Enter") {
                                    props.onRemoveOperator();
                                    toggleDropdownVisibility();
                                }
                            }}
                        >
                            {t("operators.removeOperator")}
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            )}
        </>
    );
}

export default AuthorName;